import * as weights from './style.module.css';
const fontWeights = {
    regular: weights.fontRegular,
    medium: weights.fontMedium,
    semibold: weights.fontSemiBold,
    bold: weights.fontBold,
};
export default fontWeights;
//# sourceMappingURL=fontWeights.js.map